/* @flow */

import sum from '../utils/sum';
import { type ProdutoPedido, type ComplementoItem } from './types';

const precoComplemento = (complemento: ComplementoItem) => (
    complemento.quantidade * complemento.preco
);

const precoTotalComplementos = (complementos: ComplementoItem[]) => (
    complementos
        .reduce((precoTotal, complemento) => precoTotal + precoComplemento(complemento), 0)
);

export const precoProduto = (produto: ProdutoPedido) => (
    produto.preco + precoTotalComplementos(produto.complementos || [])
);

export const precoTotalProduto = (produto: ProdutoPedido) => (
    produto.quantidade * precoProduto(produto)
);

export const precoTotalProdutos = (produtos: ProdutoPedido[]) => produtos
    .map(precoTotalProduto)
    .reduce(sum, 0);
